const topics = [
  { label: '科幻电影', count: 2840 },
  { label: '悬疑推理', count: 1920 },
  { label: '奥斯卡获奖', count: 1560 },
  { label: '韩国电影', count: 2350 },
  { label: '动画电影', count: 1780 },
  { label: '漫威宇宙', count: 1120 },
  { label: '华语电影', count: 3200 },
  { label: '纪录片', count: 960 },
  { label: '恐怖惊悚', count: 1480 },
  { label: '日剧精选', count: 1890 },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto">
        <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading text-center">
          热门话题
        </h2>
        <p className="mt-2 text-sm text-foreground-600 text-center">
          探索影迷们正在热议的电影话题
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.label}
              className="group px-5 py-3 rounded-xl bg-background-50 border border-background-200/70 hover:border-primary-200/60 hover:bg-primary-50/30 transition-all cursor-pointer"
            >
              <div className="flex items-center gap-2.5">
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors">
                  #{topic.label}
                </span>
                <span className="text-xs text-foreground-500 bg-background-100 px-1.5 py-0.5 rounded">
                  {topic.count.toLocaleString()}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}